<template>
  <v-container>
    <v-row class="px-3 pb-3" style="background-color: #f0f0f0; border-radius: 20px;">
      <v-col cols="12" md="2" align="center" class="padCardMobile">
        <v-img v-if="user.photo != null"             class="rounded-circle"
 contain width="150" height="130" :src="`${$root.$publicUrl}/files/load-image/150/150/${user.photo.id
        }/${sanitizeTitle(user.photo.name)}.${user.photo.extension}`">
        </v-img>
        <v-img v-if="user.photo == null" contain width="150" height="150" src="../assets/imagePlaceHolder.jpeg">
        </v-img>
      </v-col>
      <v-col cols="12" md="3" style="display:flex; align-items:center; text-align: left">
        <h2 style="font-family: 'roboto'; font-weight: 400; color: #282828">
          {{ user.firstname }} <br>

        </h2>
      </v-col>

      <v-col cols="12" md="5" align="right">
        <v-btn :loading="loading" class="StyleButton" @click="arquivoAlterado ? enviarArquivo() : salvarPerfil()">
          Salvar</v-btn>
      </v-col>

      <v-form style="width:100%" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" md="12">
        <v-file-input v-model="files" @change="arquivoAlterado = true" color="#ff770f" outlined
          accept="image/png, image/jpeg, image/jpg" chips prepend-icon="mdi-camera"
          placeholder="Selecione uma imagem para seu perfil (.jpeg / .jpg / .png)"></v-file-input>
      </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="user.name" label="Nome" placeholder="Nome completo" outlined color="#ff770f">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="user.email" disabled label="E-mail" placeholder="E-mail" outlined color="#ff770f">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="user.document" v-mask="`##.###.###/####-##`" label="Documento"
              placeholder="Documento" outlined color="#ff770f">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="user.phone" label="Telefone" placeholder="Telefone" v-mask="`(##) # ####-####`"
              outlined color="#ff770f">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-if="user.type == 'NATURAL PERSON'" label="Data de nascimento"
              placeholder="Data de nascimento" v-model="dataBr" outlined v-mask="`##/##/####`" color="#ff770f">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12">
            <p class="textScope" style="color: #ff770fe0">Contatos</p>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field prepend-inner-icon="mdi-earth"  v-model="user.infos.social.site" label="Website"
              placeholder="Website" outlined color="#ff770f">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field prepend-inner-icon="mdi-facebook" color="#ff770f" label="Facebook" placeholder="Facebook"
              v-model="user.infos.social.fb" outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field prepend-inner-icon="mdi-instagram" color="#ff770f" label="Instagram" placeholder="Instagram"
              v-model="user.infos.social.ig" outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field prepend-inner-icon="mdi-linkedin" color="#ff770f" label="Linkedin" placeholder="Linkedin"
              v-model="user.infos.social.linkedin" outlined>
            </v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="6">
                  <v-text-field label="Senha" placeholder="Senha" outlined>
                  </v-text-field>
                </v-col> -->

          <v-col cols="12" md="12">
            <p class="textScope" style="color: #ff770fe0">Endereço</p>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="user.address.zip_code" label="CEP" placeholder="CEP" outlined color="#ff770f"
              v-mask="`#####-###`" @keyup="buscaCEP" @blur="buscaCEP">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="user.address.street" label="Rua" placeholder="Rua" color="#ff770f" outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field v-model="user.address.number" label="Número" placeholder="Número" outlined color="#ff770f">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="user.address.complement" label="Complemento" placeholder="Complemento" outlined
              color="#ff770f">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="user.address.district" label="Bairro" placeholder="Bairro" outlined color="#ff770f">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="user.address.city" label="Cidade" placeholder="Cidade" outlined color="#ff770f">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="user.address.state.abbrev" label="Estado" placeholder="Estado" outlined
              color="#ff770f">
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-row>
<!-- 
    <v-row class="px-3 pb-3" style="background-color: #f0f0f0; border-radius: 20px; margin-top: 30px;">
      <v-col cols="12" md="12">
        <p class="textScope" style="color: #ff770fe0; margin-bottom: 0px !important">Parceria</p>
      </v-col>
      <v-col cols="12">
        <v-checkbox color="#ff770f" v-model="user.is_partner" label="">
          <template v-slot:label>
            <div>Parceiro ribus</div>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12" md="12">
        <v-file-input v-model="files" @change="arquivoAlterado = true" color="#ff770f" outlined
          accept="image/png, image/jpeg, image/jpg" chips prepend-icon="mdi-camera"
          placeholder="Selecione uma imagem para seu perfil (.jpeg / .jpg / .png)"></v-file-input>
      </v-col>
      <v-col cols="12" md="12">
        <v-select chips :items="areaOcupacao" :menu-props="{ maxHeight: '400' }" item-text="name" item-value="id"
          label="Áreas de Atuação" multiple color="#ff770f" item-color="#ff770f" outlined v-model="getCategorias">
        </v-select>
      </v-col>
      <v-col cols="12" md="12">
        <v-text-field color="#ff770f" type="number" max="100" min="0" @keyup="
          () => {
            if (this.user.infos.accepted_tokens_percentual > 100) {
              this.user.infos.accepted_tokens_percentual = 100;
            }
                return;
                }
                    " @blur="() => {
                if (this.user.infos.accepted_tokens_percentual > 100) {
                  this.user.infos.accepted_tokens_percentual = 100;
                }
                return;
              }
            " label="Porcentagem aceite ribus" placeholder="Porcentagem aceite ribus" outlined
          v-model="user.infos.accepted_tokens_percentual" append-icon="mdi-percent">
        </v-text-field>
      </v-col>


      <v-col cols="12" md="12">
        <v-textarea color="#ff770f" label="Descrição do Negócio" placeholder="Descreva seu negócio e area de atuação"
          outlined v-model="user.description">
        </v-textarea>
      </v-col>
      <v-col cols="12" md="12">
        <v-textarea color="#ff770f" label="Interesses" placeholder="Qual seu interesse no MarketPlace Ribus" outlined
          v-model="user.infos.interest">
        </v-textarea>
      </v-col>

      <v-col cols="12" md="12" align="center">
        <v-btn :loading="loading" class="StyleButton" @click="arquivoAlterado ? enviarArquivo() : salvarPerfil()">
          Salvar</v-btn>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<style scope>
@media (min-device-width: 300px) and (max-device-width: 855px) {
  .heigthMobile {
    height: auto !important;
    padding: 20px 0px;
  }

  .widthMobile {
    width: 100% !important;
  }
}

.btnMenu2 {
  color: #ffffff !important;
  border-bottom: 1px solid #ff7e00;
  background-color: transparent !important;
  background: #ff7e00 !important;
}
</style>


<script>
export default {
  name: "painelPerfil",
  data: () => ({
    date: "",
    menu2: false,
    valid: false,
    files: [],
    loading: false,
    loadingCep: false,
    birthdate: "",
    arquivoAlterado: false,
    categorias: [],
    user: {
      birthdate: "",
      is_partner: false,
      address: { state: {} },
      category_user_rels: [],
      infos: { social: {} },
    },
  }),
  computed: {
    areaOcupacao() {
      return this.$store.state.categorias;
    },
    dataBr: {
      get() {
        let dt = this.user.birthdate.split("-");
        return `${dt[2]}/${dt[1]}/${dt[0]}`;
      },
      set(newDate) {
        this.birthdate = newDate;
      },
    },
    getCategorias: {
      get() {
        let cat = [];
        this.user.category_user_rels.forEach((element) => {
          cat.push(element.category_id);
        });
        return cat;
      },
      set(nCategorias) {
        this.categorias = nCategorias;
      },
    },
  },
  mounted() {
    let tmp = this.$store.state.user;
    tmp.infos = typeof tmp.infos !== "object" ? JSON.parse(tmp.infos) : tmp.infos
    this.user = tmp
    
    if (this.user.address.state == "") {
      this.user.address.state = {};
    }
    let cat = [];
    this.user.category_user_rels.forEach((element) => {
      cat.push(element.category_id);
    });
    this.categorias = cat;
  },
  methods: {
    sanitizeTitle: function (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    enviarArquivo() {
      this.loading = true;
      const formData = new FormData();
      formData.append("file", this.files);
      this.$http
        .post("/files/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status === "OK") {
            this.user.files = [];
            this.user.files.push({
              name: response.data.result.fileName,
              value: response.data.result.identifier,
            });
            this.salvarPerfil();
          } else {
              this.$root.$emit("show-snack",{type: `error`, text: "Ocorreu um erro ao realizar o upload da imagem, verifique sua conexão e tente novamente mais tarde."});

          }
        });
    },
    buscaCEP() {
      //Verifica se campo cep possui valor informado.
      if (this.user.address.zip_code != undefined) {
        var cep = this.user.address.zip_code.replace(/\D/g, "");

        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          fetch("https://viacep.com.br/ws/" + cep + "/json")
            .then((response) => response.json())
            .then((data) => {
              this.user.address.street = data.logradouro;
              this.user.address.district = data.bairro;
              this.user.address.city = data.localidade;
              this.user.address.state.abbrev = data.uf;
              this.user.address.complement = data.complemento;
              // this.$forceUpdate();  // Notice we have to use a $ here
              this.loadingCep = false;
            });
        }
        return this.user.address.zip_code;
      }
      return this.user.address.zip_code;
    },
    salvarPerfil() {
      if (this.user.is_partner && this.categorias.length === 0) {
        this.$root.$emit("show-snack",{type: `error`, text: "Por favor escolha ao menos uma área de atuação!"});
        this.loading = false;
        return;
      }

      if (this.user.address.zip_code === undefined) {
        this.$root.$emit("show-snack",{type: `error`, text: "Por favor insira um CEP."});
        this.loading = false;
        return;
      }

      if (this.user.address.zip_code.length < 9) {
        this.$root.$emit("show-snack",{type: `error`, text: "Por favor insira um CEP válido."});
        
        this.loading = false;
        return;
      }

      this.loading = true;
      const headers = {
        "Content-Type": "application/json",
      };

      let u = {
        name: this.user.name,
        email: this.user.email,
        phone: this.user.phone,
        birthdate: this.birthdate,
        tipoPessoa: 0,
        interest: this.user.interest,
        categories: this.categorias,
        document: this.user.document,
        description: this.user.description,
        is_partner: this.user.is_partner,
        address: {
          zip_code: this.user.address.zip_code.replace(/\D/g, ""),
          street: this.user.address.street,
          number: this.user.address.number,
          district: this.user.address.district,
          complement: this.user.address.complement,
          city: this.user.address.city,
          state: this.user.address.state.abbrev,
          country_id: 1,
        },
        infos: {
          interest: this.user.infos.interest,
          accepted_tokens_percentual:
            this.user.infos.accepted_tokens_percentual,
          isWhatsapp: this.user.infos.isWhatsapp,
          social: {
            site: this.user.infos.social.site,
            ig: this.user.infos.social.ig,
            fb: this.user.infos.social.fb,
            linkedin: this.user.infos.social.linkedin,
          },
          accepted_terms: this.user.infos.accepted_terms,
        },
      };
      if (this.user.files) {
        u.files = this.user.files;
      }
      this.$http
        .post("/users/edit", u, { headers: headers })
        .then((response) => {
          if (response.data.status == "OK") {
            this.loading = false;
            window.scrollTo(0, 150);
            this.$root.$emit("show-snack",{type: `success`, text: "Perfil salvo com sucesso!"});

            //this.$store.dispatch("changeUser", u)
          }
        })
        .catch((err) => {
          let text = "";
          err.response.data.result.fields.forEach((el) => {
            if (el.message._required !== undefined) {
              text += el.message._required + "\r\n";
            } else {
              text += el.message + "\r\n";
            }
          });
          this.$root.$emit("show-snack",{type: `error`, text: text});

          this.loading = false;
        });
    },
  },
};
</script>
